import styled from 'styled-components'
import { Box, theme } from '@/client/components'
const { borders, breakpoint, color, font, space, zindex } = theme

export const Result = styled.div`
  display: block;
  height: 100%;
`

export const ResultWrapper = styled.aside`
  position: sticky;
  top: 0;
`

export const DevliveryBlockWrapper = styled.div`
  background: ${color.grayscale.lightBluev3};
  padding: 1rem 0;
`
export const ResultBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${space.xl2} 0;
  position: relative;
  @media (min-width: ${breakpoint.xl4}) {
    padding: ${space.xl2} 0 0;
  }
`
export const BoxShadow = styled(Box)`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.7;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${space.sm};
  z-index: ${zindex.sticky};
  background-color: ${color.grayscale.dark};
  color: ${color.grayscale.white};
  font-weight: ${font.weight.bold};
  font-size: ${font.size.h1};
  @media (min-width: ${breakpoint.hd}) {
    padding: ${space.xl3} ${space.xl} 0;
  }
`

export const Total = styled.span`
  display: inline-block;
  margin-bottom: ${space.sm};
  padding: ${space.xs} ${space.xl2};
  border-radius: ${borders.radius.lg};
  background-color: ${color.grayscale.light};
  color: ${color.primary.pure};
  font-family: ${font.family.heading};
  font-size: ${font.size.h3};
  font-weight: ${font.weight.bold};
  text-align: center;
  white-space: nowrap;
`

export const CurrencySwitch = styled.button`
  display: inline-block;
  background: none;
  border: none;
  margin: 0 0 ${space.lg};
  padding: 0;
  color: ${color.primary.pure};
  font-family: ${font.family.text};
  font-size: ${font.size.small};
  font-weight: ${font.weight.medium};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${color.primary.darker};
  }

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.4;
  }
`

export const Table = styled.section`
  margin-bottom: ${space.lg};
  color: ${color.text.normal};
  font-size: ${font.size.small};
  text-align: right;
  white-space: nowrap;
  width: 100%;
`
export const TableContents = styled.section`
  position: relative;
`

export const TableHead = styled.div`
  text-align: center;
  background-color: ${color.grayscale.light};
  padding-top: ${space.xs2};
  padding-bottom: ${space.xs2};
  font-weight: ${font.weight.medium};
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: ${space.xs2} ${space.xl5} ${space.xs2} 0;
  @media (min-width: ${breakpoint.xl4}) {
    min-width: 23.4rem;
    padding: ${space.xs2} ${space.xl5} ${space.xs2} ${space.xl};
    margin-bottom: 0.8rem;
  }
`

export const TableRow = styled.div<{ highlight: boolean }>`
  text-align: center;
  margin-left: 0.5rem;
  border-width: ${borders.sizes.md};
  border-style: solid;
  border-color: ${(p) => (p.highlight ? color.primary.darker : 'transparent')};
  border-radius: ${borders.radius.pill};
  cursor: pointer;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  max-width: 14rem;
  @media (min-width: ${breakpoint.xl3}) {
    max-width: 17.3rem;
  }
  @media (min-width: ${breakpoint.xl4}) {
    max-width: 16rem;
    margin-left: 3rem;
  }
`

export const TableCell = styled.div`
  padding: ${space.xs2} ${space.xs};
`

export const Checkmark = styled.i`
  display: block;
  position: absolute;
  left: 6px;
  top: calc(50% - 2px);
  width: 6px;
  height: 9px;
  border-style: solid;
  border-color: ${color.primary.pure};
  border-width: 0 ${borders.sizes.md} ${borders.sizes.md} 0;
  transform: rotate(45deg);
`

export const Delivery = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 1rem 2rem;
  gap: 0.5rem;
`
export const DeliveryHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 2rem;
  gap: 0.5rem;
  width: 100%;

  & span {
    font-size: ${font.size.xxsmall};
    color: ${color.primary.darker};
    font-family: ${font.family.text};
    font-weight: ${font.weight.medium};
  }
`

export const DeliveryType = styled.div<{ selected: boolean; disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: ${space.xs} 1rem;
  border-radius: ${borders.radius.pill};
  width: 100%;
  background: ${color.grayscale.white};
  border: ${({ selected }) =>
    selected
      ? `${borders.sizes.md} solid ${color.primary.darker}`
      : `${borders.sizes.sm} solid ${color.grayscale.lightSilver}`};
  transition: border 0.3s ease;
  cursor: pointer;
  opacity: ${(p) => (p.disabled ? 0.3 : 1)};

  & .delivery-type-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-right: 0.1rem;
    width: 90%;
  }

  & .production-type-text-block {
    & span {
      font-size: ${font.size.small};
      font-weight: ${font.weight.bold};
    }
  }
  .icon {
    margin-right: 0.3rem;
    // color: ${color.grayscale.dark};
    &:before {
      // color: ${color.grayscale.black};
    }
    @media (min-width: ${breakpoint.hd}) {
      margin-right: 0.5rem;
    }

    &.icon.super-express-production-icon-main {
      &:before {
        color: #df3800;
      }
    }
    &.icon.icon-express-production-min {
      &:before {
        color: #ffa706;
      }
    }
    &.icon.standard-icon {
      &:before {
        color: #0292c2;
      }
    }

    &.icon.checkmark-circle {
      margin-right: 0;
      margin-bottom: 3px;
    }
  }

  & .delivery-type-icon-ge {
    min-width: 1.7rem;
  }

  p {
    line-height: 1.2;
  }
`

export const IconBlock = styled.div`
  width: 10%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const QuotationMailSender = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  align-items: center;
  cursor: pointer;
  padding: ${space.xs} ${space.lg};
  margin-bottom: 0.5rem;

  & .qoutation-send {
    margin-right: 0.5rem;
  }

  & .qoutation-forwards {
    margin-left: 0.5rem;
  }
  & .qoutation-send,
  & .qoutation-forwards,
  & p {
    color: ${color.grayscale.grayWhite};
  }
`

export const QuotationContainer = styled.div`
  .background {
    position: absolute;
  }

  .modal {
    opacity: 1;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .modal-hidden {
    opacity: 0;
    transition: opacity 0.5s ease, transform 0.5s ease;
  }
`

export const AddressForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${space.lg};
  padding: ${space.sm};
`
export const DividerLine = styled.div<{ nomargin?: boolean }>`
  width: 18rem;
  border-top: none;
  border: 1px dashed ${color.grayscale.gray};
  margin-bottom: ${(p) => (p.nomargin ? 0 : space.sm)};
`

export const BestPriceBadge = styled.div<{ isUkShop: Boolean }>`
  position: absolute;
  top: ${(p) => (p.isUkShop ? '2rem' : '0.1rem')};
  right: 0rem;
`
export const BestValue = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  background: ${color.warning.warning};
  font-weight: ${font.weight.bold};
  font-size: ${font.size.mini};
  color: ${color.primary.darker};
  padding-left: 4px;
`
